<div class="simple-widget">
  <div class="widget-header">
    <itb-heading [className]="'heading widget-h'" [text]="title"></itb-heading>
    <div class="widget-icon">
      <p *ngIf="colorBars">
        <itb-color-bar [className]="'color-bar color-bar-5'"></itb-color-bar
        >OPEN
      </p>
      <p *ngIf="colorBars">
        <itb-color-bar [className]="'color-bar color-bar-6'"></itb-color-bar
        >CLOSE
      </p>
      <itb-select
        style="width: 150px;"
        *ngIf="selectItems"
        [isReactive]="false"
        [itemsStringArray]="selectItems"
        [selected]="selectedItem"
        (onSimpleChangeHandler)="selectEvent($event)"
      ></itb-select>
      <ng-container *ngIf="isDropdownButton">
        <itb-dropdown-list [dropDownButton]="dropDownButton" [items]="dropDownButtonItems" (onClickHandler)="dropdownClickEvent($event)"></itb-dropdown-list>
      </ng-container>
        <div *ngFor="let roundButtons of roundButtons">
          <itb-round-button
            [tooltipText]="roundButtons.tooltipText"
            [className]="roundButtons.className"
            [iconClassName]="roundButtons.iconClassName"
            [isLoading]="roundButtons.isLoading"
            [isDisabled]="roundButtons.isDisabled"
            (onClickHandler)="clickEvent(roundButtons.roundButtonName)"
          >
          </itb-round-button>
        </div>
    </div>
  </div>
  <itb-bar-loader *ngIf="hasBarLoader"></itb-bar-loader>
  <div class="widget-icon-hover">
    <div *ngFor="let innerRoundButtons of innerRoundButtons">
      <itb-round-button
        [tooltipText]="innerRoundButtons.tooltipText"
        [className]="innerRoundButtons.className"
        [iconClassName]="innerRoundButtons.iconClassName"
        [isLoading]="innerRoundButtons.isLoading"
        (onClickHandler)="clickEvent(innerRoundButtons.roundButtonName)"
      >
      </itb-round-button>
    </div>
  </div>
  <div
    class="widget-body"
    [ngClass]="{ 'widget-content-center': hasContentCenter }"
  >
    <ng-content></ng-content>
  </div>

  <div class="widget-footer-score" *ngIf="footerWidgetScore">
    <div
      class=" {{ items.className }} "
      *ngFor="let items of footerWidgetScore"
      (click)="footerClick(items)"
    >
      <div class="score-heading ">{{ items.scoreHeading }}</div>
      <div class="widget-spinner">
        <itb-spinner *ngIf="footerSpinner" [spinnerType]="'s'"></itb-spinner>
        <h3 *ngIf="!footerSpinner">{{ items.scoreCount }}</h3>
      </div>
    </div>
  </div>
  <div *ngIf="hasFooter" class="widget-footer">
    <itb-widget-footer
      [text]="updateText"
      [iconClassName]="footerClass"
    ></itb-widget-footer>
  </div>
</div>
